import React from 'react';
import Icon from './Icon';

const OrdersTableSearch = props => {
    const { onSubmit, value, onChange, onToggleClick } = props;
    return (
        <form className="form-search" onSubmit={onSubmit}>
            <div className="search-wrap">
                <Icon className="svg-icon" iconName="search" />
                <input className="input-text" name="searchValue" type="text" value={value} onChange={onChange} placeholder="Find order by number" autoFocus />
                <button className="btn btn-close" type="button" onClick={onToggleClick}><Icon className="svg-icon" iconName="close" /></button>
            </div>
            <button className="btn btn-bright btn-sm" type="sumit">Find order</button>
        </form>
    );
}

export default OrdersTableSearch;



// WEBPACK FOOTER //
// ./src/components/OrdersTableSearch.js